<script setup lang="ts">
import { ChevronUp } from 'lucide-vue-next'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  Button
} from '~/shared'

export interface TableColumn {
  key: string
  label: string
  visible: boolean
}

interface Props {
  columns: TableColumn[]
}

interface Emits {
  (e: 'update:columns', columns: TableColumn[]): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const toggleColumn = (columnKey: string) => {
  const updatedColumns = props.columns.map(col => 
    col.key === columnKey 
      ? { ...col, visible: !col.visible } 
      : col
  )
  emit('update:columns', updatedColumns)
}
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button
        variant="outline"
        class="flex items-center gap-2 text-sm font-normal h-10 px-3 border-slate-300"
      >
        Настройка
        <ChevronUp class="w-4 h-4" />
      </Button>
    </DropdownMenuTrigger>
    
    <DropdownMenuContent align="end" class="w-52">
      <div
        v-for="column in columns"
        :key="column.key"
        @click.stop="toggleColumn(column.key)"
        class="relative flex cursor-pointer items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none hover:bg-slate-100 focus:bg-slate-100"
      >
        <span class="absolute left-2 flex size-3.5 items-center justify-center">
          <svg
            v-if="column.visible"
            class="size-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="20,6 9,17 4,12" />
          </svg>
        </span>
        <span>{{ column.label }}</span>
      </div>
    </DropdownMenuContent>
  </DropdownMenu>
</template> 